import React, { FC } from 'react';
import { FormattedNumber } from 'react-intl';
import './LabelledNumber.css';

interface Props {
  label: string;
  number: number;
  showPrefix?: boolean;
}

const LabelledPercent: FC<Props> = ({ label, number, showPrefix }) => {
  const isPositive = number >= 0;
  const positiveNumber = Math.abs(number);
  const sign = isPositive ? '+' : '-';
  const className = isPositive ? 'green' : 'red';

  return (
    <div className="labelled-number">
      <div className="number">
        {showPrefix && (
          <span className={`${className} upper sign`}>{sign}</span>
        )}
        <div className="main-number">
          <FormattedNumber
            minimumFractionDigits={2}
            maximumFractionDigits={2}
            value={positiveNumber * 100}
          />
        </div>
        <span className="upper decimal">%</span>
      </div>
      <div className="number-label">{label}</div>
    </div>
  );
};

export default LabelledPercent;
